<template src="./diversity.html"></template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'bootstrap/dist/js/bootstrap.bundle'


import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import searchBG from '@/components/searchBG.vue';

export default {
    components: {
        searchBG,
    },
    data() {
        return {
            page : 1,
        }
    },
    created() {
        console.log('enter diversity')
    },
    computed: {
        source() {
        return this.$store.getters.getSource['diversity']
        }
    }
}
</script>
<style src="./diversity.scss" scoped lang="scss"></style>
